import { Filter } from '@anytag/shared-molecules';
import { BasicFilter } from './BasicFilter';
import { useAutoManagedCampaignsFilter } from './hooks';

export const AutoManagedCampaignsFilter = () => {
  const { filter, setFilterForm } = useAutoManagedCampaignsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <BasicFilter />
    </Filter.Provider>
  );
};

export { useAutoManagedCampaignsFilter };
export * from './schemaTypes';
